import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export default function MobileApp() {
  const { t } = useTranslation();
  return (
    <div className="flex-grow w-full max-w-4xl mx-auto p-4 sm:p-8 mt-8 flex flex-col items-center">
      <Helmet>
        <title>{t('meta_title_mobile')}</title>
        <meta name="description" content={t('meta_desc_mobile')} />
        
        {/* Social Media Meta */}
        <meta property="og:title" content={t('meta_title_mobile')} />
        <meta property="og:description" content={t('meta_desc_mobile')} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t('meta_title_mobile')} />
        <meta name="twitter:description" content={t('meta_desc_mobile')} />

        {/* Structured Data */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "WebPage",
              "name": "${t('meta_title_mobile')}",
              "description": "${t('meta_desc_mobile')}"
            }
          `}
        </script>
      </Helmet>
      <h1 className="text-3xl font-bold mb-6">{t('mobile_app_title')}</h1>
      <p className="text-white/80 text-center max-w-2xl mb-12" dangerouslySetInnerHTML={{ __html: t('mobile_app_desc') }} />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full max-w-2xl">
        <div className="bg-white/5 border border-white/10 rounded-3xl p-8 flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-gradient-to-tr from-green-400 to-green-600 rounded-xl flex items-center justify-center mb-6">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"></path>
            </svg>
          </div>
          <h2 className="text-xl font-semibold mb-2">Android App</h2>
          <p className="text-white/60 mb-6 font-mono text-sm">Status: In Development</p>
          <button className="px-6 py-2 bg-white/10 hover:bg-white/20 text-white rounded-lg transition-colors cursor-not-allowed opacity-50">
            Coming Soon to Google Play
          </button>
        </div>

        <div className="bg-white/5 border border-white/10 rounded-3xl p-8 flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-gradient-to-tr from-indigo-400 to-indigo-600 rounded-xl flex items-center justify-center mb-6">
            <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 384 512">
              <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"></path>
            </svg>
          </div>
          <h2 className="text-xl font-semibold mb-2">iOS App</h2>
          <p className="text-white/60 mb-6 font-mono text-sm">Status: In Development</p>
          <button className="px-6 py-2 bg-white/10 hover:bg-white/20 text-white rounded-lg transition-colors cursor-not-allowed opacity-50">
            Coming Soon to App Store
          </button>
        </div>
      </div>
    </div>
  );
}
